import * as React from 'react';

import { InventoryTransactionType } from '@rematter/frontend-lib-api-client';
import { cn } from '@rematter/ui-web/lib';
import { LucideExternalLink } from 'lucide-react';

import {
  ENTITY_PREFIX_MAP,
  parseOriginTransactionItemId,
} from '../../utils/entityLinks';

import { useModuleLocation } from '~/shared/hooks/useModuleLocation';

type OriginatorLinkProps = {
  originTransactionType: InventoryTransactionType;
  originTransactionItemId: string;
  className?: string;
};

export const OriginatorLink = ({
  originTransactionType,
  originTransactionItemId,
  className,
}: OriginatorLinkProps) => {
  const [, setLocation] = useModuleLocation();

  const parsed = parseOriginTransactionItemId(originTransactionItemId);

  const handleClick = React.useCallback(() => {
    if (!parsed) return;

    const config = ENTITY_PREFIX_MAP[parsed.prefix];
    if (config) {
      setLocation(config.route(parsed.parentId));
    }
  }, [parsed, setLocation]);

  if (!parsed) {
    return (
      <span className={cn('text-neutral/60', className)}>
        {originTransactionType}
      </span>
    );
  }

  const config = ENTITY_PREFIX_MAP[parsed.prefix];

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        '@OriginatorLink',
        cn(
          'group flex items-center gap-1 text-primary hover:underline',
          className,
        ),
      )}
    >
      <span>{config.label}</span>
      <LucideExternalLink className="size-3 opacity-0 transition-opacity group-hover:opacity-100" />
    </button>
  );
};
